import {Flex, Typography} from 'antd';
const AboutPage = (props) => {
    return (
        <Flex align='center' justify='center'>
            <Typography.Paragraph>
                На этом сайте можно расчитать майанский знак по дате рождения, а также скачать приложение для Android<br/>
                Этот сайт не собирает вашу информацию, т.е. если вы добавили людей в календарь, то эти данные остаются только на вашем устройстве<br/>
            </Typography.Paragraph>
        </Flex>
    )
}
export default AboutPage;